var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    { class: _vm.style_class },
    [
      _vm._t("default", null, { onInputClick: _vm.onInputClick }),
      _c("input", {
        ref: "fileInput",
        staticStyle: {
          visibility: "hidden",
          position: "absolute",
          height: "0",
        },
        attrs: {
          disabled: _vm.disabled,
          type: "file",
          accept: "image/jpeg,image/jpg,image/png,image/webp",
          multiple: _vm.multiple,
        },
        on: { change: _vm.inputFile },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }